import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemDms} from '../DM/FormChooseDm.jsx'
import Model from './ModelDt.mjs'

export const FormItemDtName = props => (
    <FormItemBizProp
        Model={Model}
        prop="dtName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemDtUserCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="dtUserCode"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseDt(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemDms />
            <FormItemDtUserCode />
            <FormItemDtName />
        </FormChooseDesign>
    )
}
